import React, { useState, useEffect } from 'react';
import MaterialTable from 'material-table';
import axios from 'axios';
import {
  language,
  dateStyle
} from 'config';
import { useHistory } from "react-router-dom";
import { useSelector} from "react-redux";
//import { FirebaseContext } from "common";
//import { setLog } from '../components/Logs';
import Loading from "../assets/loading.gif";

export default function Deliveries(props) {
  /* const { api } = useContext(FirebaseContext);
  const {
    //getEstimate,
    //clearEstimate,
    //addBooking,
    //clearBooking
  } = api; */
  //const dispatch = useDispatch();
  const history = useHistory();
  const cartypes = useSelector(state => state.cartypes.cars);
  const estimatedata = useSelector(state => state.estimatedata);
  const settings = useSelector(state => state.settingsdata.settings);
  //const userdata = useSelector(state => state.usersdata);
  // const [users, setUsers] = useState(null);
  // const [carType, setCarType] = useState(language.select_car);
  // const [pickupAddress, setPickupAddress] = useState(null);
  // const [dropAddress, setDropAddress] = useState(null);
  // const [estimateModalStatus, setEstimateModalStatus] = React.useState(false);
  // const [selectedCarDetails, setSelectedCarDetails] = useState(null);
  // const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  // const [userCombo, setUserCombo] = useState(null);
  // const [estimateRequested, setEstimateRequested] = useState(false);
  // const [bookingType, setBookingType] = useState('Book Now');
  // const [orderType, setOrderType] = useState(language.select_order_type);



  const columns = [
    { title: 'Pickup Point', field: 'pickupAdress' },
    { title: 'Dropoff Point', field: 'dropOffAdress' },
    { title: 'Order Time', field: 'creationTime', render: rowData => rowData.creationTime ? new Date(rowData.creationTime).toLocaleString(dateStyle) : null },
    { title: 'Product Name', field: 'productName' },
    { title: 'Quantity', field: 'productQuantity' },
    { title: 'Customer Name', field: 'customerName' },
    { title: 'Customer Email', field: 'customerEmail' },
    { title: 'Customer Phone Number', field: 'customerPhone' },
    { title: 'Status', field: 'status' },
  ];
  const [deliveries, setDeliveries] = useState([]);
  const [render, setRender] = useState(false);
  //function that fetches deliveries from the api
  const fetchDeliveries = async () => {
      const response = await axios.post('https://mandulisfleetapi.azurewebsites.net/api/services/app/DeliveryRequests/ListAll');
      const data_res = response.data.result.reverse()
      data_res.filter(x => x.status === 'NEW')
      console.log(data_res)
      console.log(render)
      setDeliveries(data_res);
      setRender(true)
  };
  // useEffect(() => { 
  //   // fetchDeliveries(deliveries)  
  // }, 
  // [deliveries]);
  useEffect(() => {  
       fetchDeliveries() 
       // eslint-disable-next-line
    }, [deliveries]);
  //getting only new delivery requests
  // if(deliveries){
      //setLoading(true)
     //  const newRequests = deliveries.filter(x => x.status === 'NEW');
      //setLoading(false)
  //  }
  
  /*
   const getDateString = (date) => {
    let d = null;
    d = date ? new Date(date) : new Date();

    let month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear(),
      hours = d.getHours(),
      mins = d.getMinutes();
    if (month >= 1 & month <= 9)
      month = '0' + month.toString();
    if (day >= 0 & day <= 9)
      day = '0' + day.toString();
    if (hours >= 0 & hours <= 9)
      hours = '0' + hours.toString();
    if (mins >= 0 & mins <= 9)
      mins = '0' + mins.toString();

    return [year, month, day].join('-') + 'T' + [hours, mins].join(':');
  }

  //Function to get time difference
  const dateDiff = (date) => {
    const date1 = new Date();
    const date2 = new Date(date);
    const diffTime = date2 - date1;
    return diffTime / (1000 * 60);
  }

  
  const [selectedDate, setSelectedDate] = React.useState(getDateString());
  //Loop through all new requests which are recent and create order
  const getNewBookings = () => {
    const active = [];
    for (let i = 0; i < newRequests.length; i++) {
      if (dateDiff(newRequests[i].creationTime) < 15) {
        active.push(newRequests[i]);
      };
    }
    return active
  }

  useEffect(() => {
    if (estimatedata.estimate) {
      setEstimateRequested(false);
      //setEstimateModalStatus(true);
    }
    if (userdata.users) {
      let arr = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        if (user.usertype === 'rider') {
          arr.push({
            'firstName': user.firstName,
            'lastName': user.lastName,
            'mobile': user.mobile,
            'email': user.email,
            'uid': user.id,
            'desc': user.firstName + ' ' + user.lastName + ' (' + user.mobile + ') ' + user.email,
            'pushToken': user.pushToken
          });
        }
      }
      setUsers(arr);
    }
  }, [estimatedata.estimate, userdata.users, estimateRequested]);

  const saveLogs = () => {
    const today = new Date();
    setLog("Clicked Book button", today, "Admin", "Booking Module", "Book Now", "Booking Screen");
  }
  const handleGetEstimate = (e, pickup, drop, carDetails) => {
    e.preventDefault();
    setEstimateRequested(true);
    dispatch(getEstimate({
      platform: 'web',
      pickup: pickup,
      drop: drop,
      carDetails: carDetails
    }));
  //saveLogs();
  };

  const handleEstimateModalClose = (e) => {
    e.preventDefault();
    setEstimateModalStatus(false);
    dispatch(clearEstimate());
    setEstimateRequested(false);
  };

  const handleEstimateErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearEstimate());
    setEstimateRequested(false);
  };

  const handleBookingAlertClose = (e) => {
    e.preventDefault();
    dispatch(clearBooking());
    dispatch(clearEstimate());
    clearForm();
  };

  const clearForm = () => {
    //setUserCombo(null);
    setPickupAddress(null);
    setDropAddress(null);
    setSelectedCarDetails(null);
    setCarType(language.select_car);
    setBookingType(language.book_now);
    setEstimateRequested(false);
    setOrderType(language.select_order_type)
  }

  const handleBookingErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearBooking());
    setEstimateRequested(false);
  };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  }; */
  if(render === false){
    return (
      <div>
           Loading Delivery requests  <img src={Loading} style={{ marginLeft: '10px' }} alt="" height="25px" width="25px" />
      </div>
    )
  }else if(render === true) {
  return (
    <div>
      <MaterialTable
        title={language.delivery_request}
        columns={columns}
        data={deliveries}
        style={{
          border: "2px solid gray",
          maxWidth: "1450px",
          overflow: "scroll",
          marginTop: "10px",
          marginLeft: "20px",
        }}

        options={{
          exportButton: true,
          grouping: true,
          draggable: false,
          actionsColumnIndex: -1,
          headerStyle: {
            backgroundColor: '#144216',
            color: '#FFF'
          },
          //rowStyle: { backgroundColor: "#fff" }
        }}

        actions={[
          {
            icon: 'commute',
            tooltip: language.book_delivery,
            onClick: (event, rowData) => {
              //const cartype = cartypes.filter(x => x.name === "Economy")
              const rowDat = JSON.stringify(rowData)
              const rowDa = JSON.parse(rowDat)
              //const data = Object.keys(rowData)
              //handleGetEstimate(event, rowDa.pickupAdress, rowDa.dropOffAdress, cartype );
              history.push("/addbookings");
              //const win = window.open("/addbookings", "_blank")
              //win.focus();
              /* setEstimateRequested(true);
              dispatch(getEstimate({
                platform: 'web',
                pickup: rowData.pickupAddress,
                drop: rowData.dropAddress,
                carDetails: cartypes.filter(x => x.name === "Economy"),
              })); */

              // eslint-disable-next-line
              var bookingObject = {
                pickup: rowDa.pickupAdress,
                drop: rowDa.dropOffAdress,
                //pickup: "Kalerwe, Kampala, Uganda",
                //drop: "Kajjansi, Uganda",
                carDetails: cartypes.filter(x => x.name === "Economy"),
                userDetails: {
                  uid: "bsCZVCiWPiQuNJcg0IkllfzSOAQ2",
                  profile: {
                    firstName: "Deliveries",
                    lastName: "Account",
                    mobile: "0700659758",
                    pushToken: "ExponentPushToken[y503zvF8R1-sNPLX9WhdGZ]"
                  }

                },
                estimate: estimatedata.estimate,
                tripdate: new Date().toString(),
                bookLater: false,
                settings: settings,
                booking_type_web: true,
                order_type: "Delivery"
              };

               //alert(rowData)
               //console.log("Data: " + rowDa.pickupAdress)
               //console.log("Booking" +  JSON.stringify(bookingObject))
               //alert(rowDat)
              //alert(rowData.data[0].pickupAdress)
              //alert(JSON.stringify(rowData));
              //alert(JSON.stringify(bookingObject))
              //console.log(JSON.stringify(bookingObject));
              //dispatch(addBooking(bookingObject));
            }
          }
        ]}
      />
      
      {/* <Dialog
        open={estimateModalStatus}
        onClose={handleEstimateModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{language.estimate}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {settings ? settings.symbol : null} {estimatedata.estimate ? estimatedata.estimate.estimateFare : null}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEstimateModalClose} color="primary">
            {language.cancel}
          </Button>
          {bookingType === "Ride" ?
            <Button onClick={confirmBooking} color="primary" autoFocus>
              {language.book_now}
            </Button>
            : <Button onClick={confirmDeliveryBooking} color="primary" autoFocus>
              {language.book_now}
            </Button>}
        </DialogActions>
      </Dialog>
      <AlertDialog open={bookingdata.booking ? true : false} onClose={handleBookingAlertClose}>{bookingdata.booking ? language.booking_success + bookingdata.booking.booking_id : null}</AlertDialog>
      <AlertDialog open={bookingdata.error.flag} onClose={handleBookingErrorClose}>{bookingdata.error.msg}</AlertDialog>
      <AlertDialog open={estimatedata.error.flag} onClose={handleEstimateErrorClose}>{estimatedata.error.msg}</AlertDialog>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog> */}
    </div>
    )}
}
